import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const ACCENDING = 1
const DECENDING = 0

export default function getClockTime(schoolId, params) {

  if(!schoolId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing school Id')
      })
    })
  }

  let query = queryString.stringify({
    page: params.page,
    start_date: params.start_date,
    end_date: params.end_date,
    teacher: params.teacher,
    sort_by: ACCENDING,
    statistics: params.statistics || 0,
    weekday: params.weekday || [],
    start_work_time: params.start_work_time || '',
    end_work_time: params.end_work_time || ''
  }, {strict: false, encode: false});

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/school/${schoolId}/teacher_punch/?${query}`,
    'method': 'GET',
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/teacher/getClockTime.js